import { AxiosError } from 'axios';
import { createNewFacets } from 'components/tool/Editor/ButtonDiv/api';
import { transformNewlyAddedFacets } from 'components/tool/Editor/util';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { errorResponseHandler } from 'store/api/AxiosError';
import { useMutation } from 'react-query';
import { useKonvaImageScale } from 'contexts/ToolDimensionsAndScaleContext';
import { appToast } from 'components/Basic/CustomToast';

export default function useCreateDeleteFacet() {

	const { newlyCreatedFacets, deletedRoofIndexes } = useSelector((state: RootState) => state.toolNewPostions.data);
	const defaultShading = useSelector((state: RootState) => state.QueryParams.data.defaultShading);
	const { uuid, panel, mode, designType, org } = useSelector((state: RootState) => state.roofData.data);
	const scale = useKonvaImageScale();
	const defaultFlatPitchDeg = org.setting.defaultFlatPitchDeg;
	const createNewFacetsMutation = useMutation(
		async () => {
			const newPanelFacets = transformNewlyAddedFacets({
				mode, newlyCreatedFacets, scale, designType, defaultShading, defaultFlatPitchDeg });
			if (!newPanelFacets.length && !deletedRoofIndexes.length) throw new Error('E_NO_FACET_TO_ADD_OR_DELETE');
			return await createNewFacets({ newPanelFacets, deletedRoofSegs: deletedRoofIndexes, },
				panel.key,
				uuid,
				designType,
			);
		},
		{
			onError(error: AxiosError) {
				if (error.message === 'E_NO_FACET_TO_ADD_OR_DELETE') return;
				const message = errorResponseHandler(error).message;
				appToast.error(message);
			},
			mutationKey: 'create-new-facets',
		});

	return createNewFacetsMutation;
}